export default {"src":"/_next/static/media/arrow-down-black.dd23b976.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};